import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ILoadingCellRendererAngularComp} from "ag-grid-angular";
import {IAfterGuiAttachedParams, ILoadingCellRendererParams} from "ag-grid-community";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-custom-loading-renderer',
  templateUrl: './custom-loading-renderer.component.html',
  styles: [':host {width: 100%; display: block}']
})
export class CustomLoadingRendererComponent implements ILoadingCellRendererAngularComp, OnDestroy, AfterViewInit {

    params:any;
    rows: Array<any>;
    pageSize: number = 0;
    classNamePrefix: string = 'ag-grid-page-per_';
    show:boolean = false;
  constructor(
      @Inject(DOCUMENT) private document: Document,
  ) { }

    afterGuiAttached(params?: IAfterGuiAttachedParams) {

    }

    agInit(params: ILoadingCellRendererParams): void {
        this.document.body.classList.add('cs-ag-grid-loading-enabled');
        params['paginationPageSize'] = params.api.paginationGetPageSize();
        const oldClassName = this.classNamePrefix+this.pageSize;
        if(this.pageSize > 0) {
            this.document.body.classList.remove(oldClassName);
        }
        this.pageSize = params['paginationPageSize'];
        this.document.body.classList.add(this.classNamePrefix+this.pageSize );
        const generateStep = (start, stop, step) => {
            if (stop == null) {
                stop = start || 0;
                start = 0;
            }
            if (!step) {
                step = stop < start ? -1 : 1;
            }
            const length = Math.max(Math.ceil((stop - start) / step), 0);
            const range = Array(length);
            for (let idx = 0; idx < length; idx++, start += step) {
                range[idx] = start;
            }
            return range;
        }
        this.rows = generateStep(0, params['paginationPageSize'], 1);
        this.params = params;
    }

    ngOnDestroy(): void {
        this.document.body.classList.remove(this.classNamePrefix+this.pageSize );
        this.document.body.classList.remove('cs-ag-grid-loading-enabled');
    }

    ngAfterViewInit(): void {
      setTimeout( () => {
          this.show = true;
      },100)
    }

}
